const DAYS_PER_WEEK = 7;
// Every month gets six week rows so the calendar keeps one height.
const WEEKS_SHOWN = 6;

export function buildMonthCells(year: number, month: number): (number | null)[] {
    const firstDow = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const trailing = WEEKS_SHOWN * DAYS_PER_WEEK - firstDow - daysInMonth;
    return [
        ...Array<null>(firstDow).fill(null),
        ...Array.from({ length: daysInMonth }, (_, i) => i + 1),
        ...Array<null>(trailing).fill(null)
    ];
}
